import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Celsius from "../axes/Celsius";

let DeviceTemperature = {
    type: "line",
    label: "Device Temperature",
    fill: false,
    lineTension: 0,
    colorPalette: 10,
    borderWidth:1,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Celsius,
    xAxis:Time
};

export default DeviceTemperature;



// WEBPACK FOOTER //
// ./src/components/chart/channels/DeviceTemperature.js